import { useCallback } from "react"
import { Box, TextField, InputAdornment } from "@mui/material"
import { Search } from '@mui/icons-material';


function SearchFilter({ modifiers: { selections, setSelections } }) {
    const handleChange = useCallback((event) => {
        const nextValue = event.target.value
        setSelections(state => ({ ...state, searchQuery: nextValue }))
    }, [setSelections])

    return (
        <Box sx={{ width: '100%' }}>
            <TextField
                id="search-filter"
                label="Stock No. or Report No."
                value={selections.searchQuery}
                onChange={handleChange}
                type="search"
                variant="outlined"
                fullWidth
                size="small"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    )
}

export default SearchFilter
